import React from 'react';
import {Link} from "react-router-dom";
import {Spinner} from "reactstrap";
import {InputEmail} from 'components/common/InputEmail';
import {InputPassword} from 'components/common/InputPassword';
// import {ButtonFacebook} from 'components/common/ButtonFacebook';
// import {ButtonGoogle} from 'components/common/ButtonGoogle';
import {app} from "app/app";
import 'assets/sass/login/LoginForm.scss';
import { ConfirmationTokenNotice } from 'buenLib/components/ConfirmationTokenNotice';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {getSetting, KEYS} from "../../settings/settings";


export function LoginForm(props) {
    const allRoutes = app.routes();
    const { executeRecaptcha } = useGoogleReCaptcha();

    async function handleSubmit(ev) {
        ev.preventDefault();
        const reCaptchaToken = getSetting(KEYS.RECAPTCHA_SITE_KEY) && executeRecaptcha ? await executeRecaptcha('login') : undefined;
        props.handleLogin(reCaptchaToken);
    }

    function renderSubmitButton() {
        const definedRecaptchaKey = !!getSetting(KEYS.RECAPTCHA_SITE_KEY);

        if (props.operationInProcess) {
            return <Spinner className="spinner-color"/>
        } else {
            return <button className={`cta-button ${!executeRecaptcha && definedRecaptchaKey && 'disabled'}`}>INGRESAR</button>
        }
    }

    return (
        <div className="login-form">
            <form onSubmit={handleSubmit}>
                <ConfirmationTokenNotice
                    confirmationTokenRequiredResponse={props.confirmationTokenRequiredResponse}
                    confirmationToken={props.confirmationToken}
                    onConfirmationTokenChange={props.onConfirmationTokenChange}
                    actions={
                        <div className="login-form-footer">
                            {/*<ButtonFacebook/>*/}
                            {/*<ButtonGoogle/>*/}
                            {renderSubmitButton()}
                        </div>
                    }
                >
                    <InputEmail placeholder="Ingresá tu email" label="Email"
                                errorMessage={props.formData.email.error} onChange={props.handleInputChange}/>
                    <InputPassword placeholder="Ingresá tu contraseña" label="Contraseña"
                                errorMessage={props.formData.password.error}
                                onChange={props.handleInputChange} withValidation={false}/>
                    <div className="form-error">{props.generalError}</div>
                    <p>¿Olvidaste tu contraseña? <Link to={allRoutes.session.forgotPassword}>Clic aquí</Link></p>
                </ConfirmationTokenNotice>
            </form>
        </div>
    );
}
